import {
  Spacing
} from 'UI'

export default theme => ({
  infos: {
    display: 'flex',
    flexDirection: 'column',
    padding: () => Spacing(5),
    margin: ({ margin }) => margin || null
  },
  icons: {
    color: theme.secondary[0]
  },
  rateStarsClass: {
    cursor: 'pointer'
  },
  infosLines: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: ({ gutterBottomForInfoLines }) => gutterBottomForInfoLines ? 12 : 0
  },
  infosLinesViewers: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: ({ infosLinesNoPadding }) => infosLinesNoPadding ? 0 : 12
  },
  lastInfosLines: {
    display: 'flex',
    alignItems: 'center'
  }
})
